module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAATxJREFUKBV1kT1LxEAQhrMJEUFsbAR7k0KtglYWWpwW+YADLWwFsbrSPv4MsRViYaEkwcbCykasJWktLbSyEEN8ds0euSUO7My+M/PO7MwKCwnD8BjzVZbltcRDQs4u/okQ4txJkmSxbdsnzqHv+6Ku60eTBGGfeI5/g/PmVFX17XneMmCTwI5J7Ai3xOfp8uK67sQBWFS/z7JshWvQJ5oE4qM8zz+FJEkhWURRdIE9kZiqV9wPuKoO2BEzf6iYVFpMovTLJ2GmBOmzpdJCQmvb9g34R/uwD7qD9qmZNIjjeK9pmjvwHAXesQucbXM5U1KPoGfYgrgEaWY5YEuRBghqBrZaDG1VsNZ1FvBMAd1hZmhzOXQ/s1Gr/xHkU4i3RVGcYi8lRo7UP/G8tSAIqjRN+1v7S+l013EMfP0FQWyzBKpNVggAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cross.png
// module id = 246
// module chunks = 0